import React from 'react';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';

interface Props {
  onRequestClose(): void;
}

export const QuovoDisabledMessageModal: React.FC<Props> = ({ onRequestClose }) => {
  return (
    <Modal isOpen onRequestClose={onRequestClose}>
      <ModalHeader variant="warning">
        <Box as="span" css="text-transform: capitalize">
          Warning
        </Box>
      </ModalHeader>
      <ModalCloseButton onClick={onRequestClose} />

      <ModalBody>
        We are changing the way accounts are aggregated and linked to your institutions. This
        functionality is currently disabled pending action by your advisor. Please try again later.
      </ModalBody>

      <ModalFooter>
        <Button ml="12" onClick={onRequestClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
